import React from "react"
import Base from "../core/Base"

const UserDashBoard = () => {
    return(
        <Base title = "User Dashboard Page">
          <h1>this is the User Dashboard Page!</h1>
        </Base>
    )
}

export default UserDashBoard